import React from 'react';
import UpperMessagePopUp from '../transactions/components/UpperMessagePopUp';
import { USER_MESSAGE_TYPES } from './constants';
import { IMessageData } from '../../store/createUserMessageSlice';
import InfoPopup from '../dashboard/components/InfoPopup';

interface IProps {
  userMessageObject: IMessageData;
}
const UserMessageSwitch = ({ userMessageObject }: IProps) => {
  const {
    type, callback, messageText, iconSource, autoCloseTimeout, needSpinner, processingText, useLottie, messageTitle, secondaryHandleState,
    secondaryButtonText, secondaryButtonClassName, buttonClassName, mainButtonText, isLoading, handleManualLoading, containerClassName, pictureClassName,
    titleClassName, messageTextClassName, needIconX, xIconSrc, xButtonClassName, popupHeight, mainButtonClassName, overrideContainerClassName, customModal,
  } = userMessageObject;

  const handleClose = () => {
    if (callback) callback();
  };

  const renderSwitch = () => {
    switch (type) {
      case USER_MESSAGE_TYPES.UPPER_MESSAGE:
        return <UpperMessagePopUp useLottie={useLottie} processingText={processingText ?? ''} needSpinner={needSpinner ?? false} autoCloseTimeout={autoCloseTimeout} handleClose={handleClose} iconSource={iconSource} messageText={messageText ?? ''} />;
      case USER_MESSAGE_TYPES.POP_UP:
        return (
          <InfoPopup
            popupHeight={popupHeight}
            xButtonClassName={xButtonClassName}
            xIconSrc={xIconSrc}
            needIconX={needIconX}
            textClassName={messageTextClassName}
            titleClassName={titleClassName}
            pictureClassName={pictureClassName}
            className={containerClassName}
            handleManualLoading={handleManualLoading}
            isLoading={isLoading}
            mainButtonText={mainButtonText}
            buttonClassName={buttonClassName}
            mainButtonClassName={mainButtonClassName}
            secondaryButtonClassName={secondaryButtonClassName}
            secondaryButtonText={secondaryButtonText}
            secondaryHandleState={secondaryHandleState}
            additionalCallback={callback}
            handleState={() => {}}
            pictureSrc={iconSource}
            showInfoPopup
            text={messageText ?? ''}
            title={messageTitle ?? ''}
            overrideContainerClassName={overrideContainerClassName}
          />
        );
      case USER_MESSAGE_TYPES.ZERO_STATE:
        return <div hidden />;
      case USER_MESSAGE_TYPES.USER_MESSAGE:
        return <div>{customModal}</div>;
      default:
        return <div hidden />;
    }
  };

  return renderSwitch();
};

export default UserMessageSwitch;
